import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const ProductContainerHeader = styled.div `
    width: 100%;
    font-size: 18px;

    div:first-child {
      display: flex;
      align-items: center;
      border-bottom: solid 1px ${purpurColorPurple800};
    }

    div:last-child {
      margin-top: ${spacing.spacing8};
    }
  }
`;
export const Heading = ({ icon, mainHeading, subHeading }) => {
    return (_jsxs(ProductContainerHeader, { children: [_jsxs("div", { children: [icon, _jsx("span", { children: mainHeading })] }), _jsx("div", { children: subHeading })] }));
};
